module.exports = __webpack_public_path__ + "static/media/edit-icon.a9a5c688.svg";